import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import $ from 'jquery';
import {debounce} from 'lodash';

import template from './Taxes.rt';
import {modifyPageLayoutComponents} from "../PageLayout";
import TaxesHeader from "./TaxesHeader";
import TaxesFooter from './TaxesFooter';
import {
  getTaxGroups, getTaxLocations,setCurrentGroup,
  addNewItem, removeItem, updateItem, setItemsGroup, itemsDrillDown,
  breadCrumbItemClick, setSearchText, setFilterGroup
} from "./TaxesActions";
import {getBreadCrumbItems, getVisibleItems} from "./TaxesReducer";
import TaxesRegions from './TaxesRegions';

class TaxesControl extends Component
{
  constructor(props) {
    super(props);

    this.state = {
      groupDropDownVisible: false
    }

    this.refGroupDropDown = null;
  }

  componentDidMount() {
    this.props.getTaxLocations();
  }

  componentDidUpdate(prevProps) {
    // if (this.props.level !== prevProps.level) {
    //   this.props.getTaxLocations(this.props.level)
    // }
  }

  showGroupDropDown = show => {
    this.setState({groupDropDownVisible: show}, () => {
      if (show)
        this.refGroupDropDown.focus();
    });
  }

  selectGroup = group => {
    TaxesRegions.currentRegion.setCurrentGroupAtLevel(this.props.level, group);
    this.setState({groupDropDownVisible: false}, () => {

    });
  }

  makeItemEditable = (item, propertyName) => {
    this.props.updateItem(item, true, propertyName, false, false);
    setTimeout(() => {
      const el = $(`#${propertyName}_${item.id || item.uid}`);
      el.focus();
      $(el).selectionStart = $(el).selectionEnd = 1000; // TODO
    }, 100);
  }

  render = template;
}

const sp = state => {
  const {taxes} = state;
  const taxRegion = TaxesRegions.currentRegion;
  return {
    visibleItems: getVisibleItems(taxes),
    breadCrumbItems: getBreadCrumbItems(taxes),
    ...taxes,
    taxRegion
  }
};

const dp = dispatch => {
  const _setSearch = debounce(q => dispatch(setSearchText(q)));
  return {
    addNewItem: () => dispatch(addNewItem()),
    removeItem: (item) => dispatch(removeItem(item)),
    updateItem: (item, value, propertyName, isNumber, markAsChanged) => dispatch(updateItem(item, propertyName, value, isNumber, markAsChanged)),
    getTaxGroups: parentId => dispatch(getTaxGroups(parentId)),
    getTaxLocations: () => dispatch(getTaxLocations()),
    setCurrentGroup: group => dispatch(setCurrentGroup(group)),
    setItemsGroup: group => dispatch(setItemsGroup(group)),
    itemsDrillDown: parentItem => dispatch(itemsDrillDown(parentItem)),
    breadCrumbItemClick: item => dispatch(breadCrumbItemClick(item)),
    setSearchText: _setSearch,
    setFilterGroup: (region, group) => dispatch(setFilterGroup(region, group))
  }
};

const connector = connect(sp, dp);
export const TaxControlLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(TaxesHeader),
  content: connector(TaxesControl),
  pageFooter: TaxesFooter
});

